import { createSlice } from '@reduxjs/toolkit'
import { INTERNAL_CONSTANTS } from '@constants/internalConstants'

const initialState = {
  details: {
    playerId: null,
    token: null,
    gameCode: null,
    operatorId: null,
    brandId: null,
    operatorName: null,
    brandName: null,
    gameMode: null,
    language: null,
    accessToken: null,
  },
  authenticationStatus: INTERNAL_CONSTANTS.AUTHENTICATION_STATUS.IDLE, // 'IDLE' | 'PENDING' | 'SUCCEEDED' | 'FAILED'
}

const sessionSlice = createSlice({
  name: 'session',
  initialState,
  reducers: {
    setSessionDetails: (state, action) => {
      const {
        playerId,
        token,
        gameCode,
        gameMode,
        language,
        accessToken,
        // operator identifiers are nested under `operator` in the init response
        operator,
      } = action.payload
      state.details = {
        playerId,
        token,
        gameCode,
        operatorId: operator?.operatorId ?? null,
        brandId: operator?.brandId ?? null,
        operatorName: operator?.operatorName ?? null,
        brandName: operator?.brandName ?? null,
        gameMode,
        language,
        accessToken,
      }
    },
    setAuthenticationStatus: (state, action) => {
      state.authenticationStatus = action.payload
    },
  },
})

export const { setSessionDetails, setAuthenticationStatus } = sessionSlice.actions
export default sessionSlice.reducer
